import { render } from "./admin-layout.vue?vue&type=template&id=04b45205"
import script from "./admin-layout.vue?vue&type=script&lang=js"
export * from "./admin-layout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__